
.questionChoice,
.questionChoiceSelected,
.questionPoints {
  position: relative;
  padding-top: 60%;
  width: 100%;
  height: 0;
}
.height-auto {
  height: auto;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.points {
  width: 100%;
  position: absolute;
  top: 30%;
  text-align: center;
  font-size: 1rem;
}
.questionChoice {
  background: #fff;
}
.questionChoiceSelected {
  background:var(--primary-color);
}

.questionBody {
  border: 1px solid #ddd;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 1rem;
}

.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
hr.question {
  margin-top: 5px;
  margin-bottom: 5px;
  height: 1.5px;
  border: 0;
  background:var(--primary-color);
}
.questionIndex {
  font-size: 0.8rem;
  color:var(--primary-color);
}
.questionTrunk {
  color:var(--primary-color);
  font-size: 2.5rem;
}
.answerContainer {
  display: flex;
}
.answer {
  flex: 1;
}
.answer > input[type="radio"] {
  opacity: 0;
}
.answer > input[type="checkbox"] {
  position: inherit;
  opacity: 0;
}
.answer > .answerLabel {
  border-radius: 0;
  background:var(--primary-color);
  color: #fff;
  width: 95%;
  font-size: 1.8rem;
  min-height: 38px;
}
.questionBody .col-md-6 {
  position: inherit;
}
.standard-btn {
  background-color: #fff;
  width: 180px;
}
.standard-btn:hover {
  color: #fff;
  background-color:var(--primary-color);
}
.answerIndex {
  color: #fff;
  font-weight: 700;
}
.answerButton {
  background-color: #f7b600;
  width: 100%;
}

.vue-dialog .dialog-c-title {
  font-size: 18px;
  color: #000;
}
.vue-dialog .dialog-c-text {
  font-size: 16px;
  color: #000;
}
.vue-dialog .vue-dialog-button {
  font-size: 16px !important;
  color: #000;
}
.answer input[type="checkbox"] + label:before {
  position: inherit;
  content: "";
  border: 0 solid #ccc;
  border-radius: 3px;
  background-color:var(--primary-color);
  color: #fff;
  width: 24px;
  height: 24px;
}
.answer input[type="checkbox"]:checked + label {
  background: #fdb913;
  color:var(--primary-color);
}

.answer input[type="checkbox"]:checked + label:before {
  background: #fdb913;
  color:var(--primary-color);
}

.answer input[type="radio"]:checked + label {
  background: #fdb913;
  color:var(--primary-color);
}

.answer input[type="radio"]:checked + label:before {
  background: #fdb913;
  color:var(--primary-color);
}

/* START GENAI@CHATGPT4 */
.answer input[type="checkbox"]:focus + label,
.answer input[type="radio"]:focus + label {
  border: 1px solid var(--form-input-border-focus-color);
  outline: 1px dashed var(--form-input-outline-focus-color);
  outline-offset: 4px;
}

/* END GENAI@CHATGPT4 */


.answer input[type="radio"] + label:before {
  content: "";
  border: 0 solid #ccc;
  border-radius: 3px;
  background-color:var(--primary-color);
  color: #fff;
  width: 24px;
  height: 24px;
}
.result-divider-line {
  border-top: 1px solid #5c5c5c;
  opacity: 0.25;
}

@media only screen and (max-width: 414px) {
  .questionTable .category,
  .questionTable .numberOfPoints {
    font-size: 0.8rem;
  }
}
@media only screen and (min-width: 740px) {
  .answerLabel:active,
  .answerLabel:hover {
    color: #f7b600;
  }
  .answerIndex:active,
  .answerIndex:hover {
    color: #f7b600;
  }
}
